import React from 'react'
import PropTypes from 'prop-types'
// MUI Components
import { ListItem, ListItemText, Divider, Typography } from '@mui/material'

const QuestMessage = ({ uniqueId, background, task, label, turn, secondaryText }) => {
  // Determine avatar properties based on the role

  return (
    <div>
      <ListItem>
        <ListItemText align="center" primaryTypographyProps={{ sx: { fontWeight: 'bold' } }} primary={'Quest ' + turn + ' - ' + label}> </ListItemText>
      </ListItem>
      <ListItem key={uniqueId}>

        <ListItemText
          align="left"
          primary={
            <div>
              <Typography component="p" variant="body1">
                <strong>Background:</strong> {background}
              </Typography>
              <br></br>
              <Typography component="p" variant="body1">
                <strong>Task:</strong> {task}
              </Typography>
            </div>
          }
          secondary={ secondaryText }
          style={{ wordBreak: 'break-word', maxWidth: '100%' }}
        />
      </ListItem>
      <Divider />
    </div>
  )
}

QuestMessage.propTypes = {
  uniqueId: PropTypes.number.isRequired,
  task: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  turn: PropTypes.number.isRequired,
  secondaryText: PropTypes.string
}

export default QuestMessage
